import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgIdentityVerificationNeeded(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 31.515a6 6 0 0 1 6-6h46.903a6 6 0 0 1 6 6v63.86a6 6 0 0 1-6 6H24a6 6 0 0 1-6-6v-63.86Z"
        fill="#007A5F"
      />
      <path
        d="M22.243 32.899a3 3 0 0 1 3-3H69.66a3 3 0 0 1 3 3V93.88a3 3 0 0 1-3 3H25.243a3 3 0 0 1-3-3V32.9Z"
        fill="#fff"
      />
      <path
        d="M52.414 20.375a1.2 1.2 0 0 0-1.2-1.2H44.65a1.2 1.2 0 0 0-1.2 1.2v3.683a1.2 1.2 0 0 0 1.2 1.2h6.564a1.2 1.2 0 0 0 1.2-1.2v-3.683Zm1.6 3.683a2.8 2.8 0 0 1-2.8 2.8H44.65a2.8 2.8 0 0 1-2.8-2.8v-3.683a2.8 2.8 0 0 1 2.8-2.8h6.564a2.8 2.8 0 0 1 2.8 2.8v3.683Z"
        fill="#0F172A"
      />
      <path
        d="M37.848 24.256a3 3 0 0 1 3-3h13.207a3 3 0 0 1 3 3v5.524a3 3 0 0 1-3 3H40.848a3 3 0 0 1-3-3v-5.524Z"
        fill="#78B441"
      />
      <path
        d="M34.968 32.78c0-1.591 1.29-2.881 2.88-2.881h19.207a2.88 2.88 0 1 1 0 5.762H37.849a2.881 2.881 0 0 1-2.881-2.881Z"
        fill="#78B441"
      />
      <path
        d="M64.737 80.035a.8.8 0 0 1 0 1.6H40.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 0 1 0 1.6H40.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H40.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H40.73a.8.8 0 1 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H40.73a.8.8 0 1 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H40.73a.8.8 0 1 1 0-1.6h24.008Z"
        fill="#B3C0D0"
      />
      <path
        d="M35.235 51.546c0-.188-.023-.372-.063-.55l-1.99 1.96a.8.8 0 0 1-1.123 0l-.853-.84a.8.8 0 0 1 1.122-1.14l.292.287 1.693-1.667a2.632 2.632 0 0 0-1.693-.611c-1.456 0-2.615 1.159-2.615 2.561s1.16 2.56 2.615 2.56c1.455 0 2.615-1.157 2.615-2.56Zm1.6 0c0 2.31-1.9 4.161-4.215 4.161-2.316 0-4.214-1.851-4.214-4.161 0-2.31 1.898-4.16 4.214-4.161 1.09 0 2.087.41 2.838 1.084l.869-.855a.8.8 0 0 1 1.123 1.141l-1.023 1.005a4.1 4.1 0 0 1 .407 1.786ZM35.235 64.03c0-.188-.023-.372-.063-.55l-1.991 1.96a.8.8 0 0 1-1.122 0l-.854-.84a.8.8 0 0 1 1.123-1.14l.291.287 1.694-1.667a2.631 2.631 0 0 0-1.694-.611c-1.455 0-2.614 1.159-2.614 2.561 0 1.403 1.159 2.56 2.615 2.56 1.455 0 2.615-1.157 2.615-2.56Zm1.6 0c0 2.31-1.9 4.161-4.215 4.161-2.316 0-4.214-1.851-4.214-4.16 0-2.31 1.898-4.162 4.214-4.162 1.089 0 2.087.41 2.837 1.084l.87-.854a.8.8 0 0 1 1.123 1.14l-1.023 1.005a4.1 4.1 0 0 1 .407 1.786ZM35.235 77.475a2.51 2.51 0 0 0-.063-.55l-1.991 1.96a.8.8 0 0 1-1.122 0l-.854-.84a.8.8 0 0 1 1.123-1.14l.291.287 1.694-1.667a2.631 2.631 0 0 0-1.694-.612c-1.455 0-2.614 1.16-2.614 2.562s1.159 2.56 2.615 2.56c1.455 0 2.615-1.158 2.615-2.56Zm1.6 0c0 2.31-1.9 4.161-4.215 4.161-2.316 0-4.214-1.852-4.214-4.161 0-2.31 1.898-4.161 4.214-4.161 1.089 0 2.087.41 2.837 1.084l.87-.855a.8.8 0 0 1 1.123 1.14l-1.023 1.006a4.1 4.1 0 0 1 .407 1.786Z"
        fill="#78B441"
      />
      <path d="M58.015 29.1a.8.8 0 1 1 0 1.599H41.69a.8.8 0 1 1 0-1.6h16.325Z" fill="#0F172A" />
      <path
        d="M100.79 50.803 63.041 40.69a4.375 4.375 0 0 0-5.359 3.093L50.99 68.76a4.375 4.375 0 0 0 3.094 5.358l37.748 10.115a4.375 4.375 0 0 0 5.359-3.094l6.693-24.977a4.376 4.376 0 0 0-3.094-5.359Z"
        fill="#F1F5F9"
      />
      <path
        d="m63.041 40.689 37.749 10.114a4.377 4.377 0 0 1 3.094 5.359l-.705 2.629-46.201-12.38.704-2.629a4.377 4.377 0 0 1 5.359-3.093Z"
        fill="#78B441"
      />
      <path
        d="m58.884 53.322-3.896 14.52a2.625 2.625 0 0 0 1.855 3.216l12.298 3.3c1.4.375 2.84-.455 3.215-1.856l3.897-14.52a2.625 2.625 0 0 0-1.856-3.215l-12.297-3.3a2.625 2.625 0 0 0-3.216 1.855Z"
        fill="#A6DBCB"
      />
      <path
        d="M58.57 67.955a5.227 5.227 0 0 1 6.399-3.694 5.226 5.226 0 0 1 3.694 6.398l-.908 3.39-10.101-2.707.908-3.39.009.003ZM65.118 63.703a2.905 2.905 0 1 0 1.504-5.612 2.905 2.905 0 0 0-1.504 5.612Z"
        fill="#007A5F"
      />
      <path
        d="M50.217 68.553 56.23 46.11a.8.8 0 1 1 1.546.414l-6.014 22.442a3.577 3.577 0 0 0 2.528 4.379l33.523 8.982a.8.8 0 1 1-.414 1.545l-33.523-8.982a5.177 5.177 0 0 1-3.659-6.338Z"
        fill="#0F172A"
      />
      <path
        d="M97.786 62.017a.8.8 0 0 1-.414 1.545l-17.7-4.743a.8.8 0 1 1 .414-1.545l17.7 4.742Z"
        fill="#78B441"
      />
      <path
        d="M86.661 76.484a.8.8 0 1 1-.414 1.545l-10.937-2.93a.8.8 0 1 1 .414-1.546l10.937 2.93ZM94.33 74.915a.8.8 0 0 1-.415 1.545l-17.7-4.743a.8.8 0 1 1 .415-1.545l17.7 4.743ZM95.235 71.534a.8.8 0 0 1-.414 1.545l-17.7-4.743a.8.8 0 1 1 .415-1.545l17.7 4.743ZM96.88 65.397a.8.8 0 0 1-.414 1.546l-17.7-4.743a.8.8 0 1 1 .414-1.545l17.7 4.742Z"
        fill="#B3C0D0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgIdentityVerificationNeeded)
